export default "__VITE_ASSET__CMYiyW50__"